module.exports = __webpack_public_path__ + "static/media/left.f8f06797.svg";